import file_utils from "./fileUtils";
import util from "../../../global/utils/Helpers";

const uploadFile = (
  file,
  fileType,
  application_id,
  fileStatusUpdate,
  name,
  sectionName,
  documentAuth,
  page_index
) => {
  const path = window.location.pathname.split("/");
  let formId = path[3];
  let appId = path[4];
  application_id = file_utils.getApplicationId();
  let fileUploadService;
  const isLocalHost = util.isLocalhost();
  const localBase = "http://localhost:9393/auth/document";
  if (documentAuth && documentAuth === "dh") {
    fileUploadService = isLocalHost
      ? `${localBase}/dh/${appId}`
      : `${util.getCurrentHost()}/auth/auth/document/dh/${appId}`;
  } else {
    fileUploadService = isLocalHost
      ? `${localBase}/ef/${formId}/${appId}`
      : `${util.getCurrentHost()}/auth/auth/document/ef/${formId}/${appId}`;
  }

  if (file_utils.isValidFile(file, file_utils.getMimeTypes(fileType))) {
    // TODO: instead of passing empty object for owner
    // lets create a util to get the user's subject id
    // Object.assign(file, { document_path: `/${application_id ? application_id : file.machine_name}/${file.name}`, owner: {}, created_date: new Date().toISOString() });
    let xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open("post", fileUploadService, true);
    xhr.setRequestHeader("CSRF-Token", window["CSRF-Token"]);
    let formData = new FormData();
    let documentpath = `/${
      application_id ? application_id : file.machine_name
    }/${file.name}`;

    formData.append("files", file);
    formData.append("application_id", application_id);
    formData.append("form_id", fileType); //not used
    formData.append("user_id", "x"); //not used
    formData.append("fileType", fileType);

    let uuid = file.lastModified + new Date().getTime();

    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable) {
        let extraData = {
          machine_name: name,
          application_id: application_id,
          FileType: fileType ? fileType.toString() : "",
          fileType: sectionName,
          document_name: file.name,
          size: e.total,
          displayName: fileType ? fileType.toString() : "",
          lastModified: uuid,
          state: "process",
          percentage: 50,
          document_path: documentpath,
          page_index: page_index ? page_index : null,
        };
        fileStatusUpdate(extraData);
      }
    };

    xhr.onerror = function (e) {
      let extraData = { name: file.name, operation: "delete", state: "failed" };
      fileStatusUpdate(extraData);
    };
    xhr.onload = function (e) {
      let data = JSON.parse(xhr.responseText);
      if (xhr.status >= 300) {
        fileStatusUpdate({
          name: file.name,
          operation: "delete",
          state: "failed",
        });
      } else {
        documentpath = `/${
          application_id ? application_id : file.machine_name
        }/${data.filename}`;
        let extraData = {
          machine_name: name,
          application_id: application_id,
          FileType: fileType ? fileType.toString() : "",
          fileType: sectionName,
          document_name: file.name,
          size: e.total,
          displayName: fileType ? fileType.toString() : "",
          lastModified: uuid,
          state: "complete",
          percentage: 100,
          document_path: documentpath,
          page_index,
        };
        fileStatusUpdate(extraData);
      }
    };

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        let data = JSON.parse(xhr.responseText);
        if (
          data &&
          data["message"] &&
          data["message"] === "Document Uploaded successfully!"
        ) {
          util.fileExists(application_id, file.name).then((exists) => {
            if (!exists) {
              fileStatusUpdate({
                name: file.name,
                operation: "delete",
                state: "failed",
              });
            }
          });
        }
      }
    };

    xhr.send(formData);
  }
};

export default uploadFile;
